import IcUserIcon from './component'

export default IcUserIcon
